import { z } from 'zod';
import { BI_EVENT_TYPES } from './bi-analytics.constants';
import type { BIEventData, BIEventType } from './bi-analytics.types';

const BIEventDataSchema = z
  .object({
    disabled: z.boolean().optional(),
  })
  .catchall(z.unknown());

export const isBIEventType = (value: string): value is BIEventType =>
  BI_EVENT_TYPES.has(value);

export const getClickAnalyticsElement = (
  target: EventTarget | null,
): Element | null => {
  if (!(target instanceof Element)) {
    return null;
  }

  if (target.hasAttribute('data-analytics-type')) {
    return target;
  }

  return target.closest('[data-analytics-type]');
};

export const parseAnalyticsPropsFromAttribute = (
  raw: string | null,
): BIEventData | undefined => {
  if (!raw) {
    return undefined;
  }

  const parsed: unknown = JSON.parse(raw);
  return BIEventDataSchema.parse(parsed);
};

export const serializeBIEventData = (
  eventData?: BIEventData,
): string | undefined => (eventData ? JSON.stringify(eventData) : undefined);

export const extractActionText = ({
  element,
  maxSize,
}: {
  element: Element;
  maxSize: number;
}): string | undefined => {
  if (!(element instanceof HTMLElement)) {
    return undefined;
  }

  const text =
    element.innerText?.trim() || element.getAttribute('aria-label')?.trim();
  if (!text) {
    return undefined;
  }

  return text.slice(0, maxSize);
};
